import { useRef } from "react";
import { Tooltip } from "./Tooltip";
import { Link } from "react-router-dom";

export function CircleLink({path, icon, tooltip='',disableAfterClick=false,color='text-white bg-indigo-500 hover:bg-indigo-600 hover:text-white'}) {
  const btnRef = useRef(null);
  
  return (
    <div className='relative group'>
      <Link
        to={path}
        className={`${color} flex h-8 w-8 items-center justify-center rounded-full text-lg cursor-pointer`}
      >
        <i className={icon}></i>
      </Link>
      <Tooltip text={tooltip}></Tooltip>
    </div>
  ); 
}